/* eslint-disable no-console */
import axios from 'axios';
import { API_URL } from './../parameters.js';

const api = axios.create({
	baseURL: API_URL,
	withCredentials: process.env.NODE_ENV === 'development',
	crossDomain: true,
	origin: API_URL,
	headers: {
		common: {
			'Cache-Control': 'no-cache'
		}
	}
});

export default api;


// WEBPACK FOOTER //
// ./services/Api.js